<app-auth-form
  [isRegister]="isRegister"
  [errorMessage]="errorMessage"
  [loading]="isLoading"
  [choices]="choices"
  [choicesTitleKey]="choicesTitleKey"
  [choicesSubtitleKey]="choicesSubtitleKey"
  [backLabelKey]="backLabelKey"
  (choiceSelect)="onChoice($event)"
  (backClick)="backToChoices()"
  (formSubmit)="onLogin($event)"
  (cancelMFA)="cancelMFA()"
></app-auth-form>
